const req = (method: string, path: string, body?: unknown) =>
  fetch(`/api/admin${path}`, {
    method,
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: body !== undefined ? JSON.stringify(body) : undefined,
  }).then(async (res) => {
    if (!res.ok) {
      const text = await res.text().catch(() => res.statusText);
      throw new Error(text || `HTTP ${res.status}`);
    }
    if (res.status === 204) return undefined;
    return res.json();
  });

export interface Org {
  id: string;
  name: string;
  user_count: number;
  created_at: string;
}

export interface OrgKB {
  id: string;
  name: string;
  description: string;
  assigned: boolean;
}

export const orgApi = {
  list: (): Promise<Org[]> => req('GET', '/orgs'),
  create: (name: string): Promise<Org> => req('POST', '/orgs', { name }),
  update: (id: string, name: string): Promise<{ id: string; name: string }> =>
    req('PATCH', `/orgs/${id}`, { name }),
  delete: (id: string): Promise<void> => req('DELETE', `/orgs/${id}`),
  getKbs: (id: string): Promise<OrgKB[]> => req('GET', `/orgs/${id}/kbs`),
  setKbs: (id: string, kb_ids: string[]): Promise<unknown> =>
    req('PUT', `/orgs/${id}/kbs`, { kb_ids }),
};
